/**
 * Toggle active classes after clicking the slide indicator
 * @param {Object} element - The selected object from the html markup
 */

function switchSlide(element) {
    const slides = element.querySelectorAll('.slider_items--item')
    const indicator = element.querySelectorAll('.slider_indicator--item')

    if (slides.length > 0) {
        slides[0].classList.add('active')
    }

    if (slides.length > 1) {
        indicator[0].classList.add('active')

        indicator.forEach(function (item) {
            item.addEventListener('click', () => {
                slides.forEach(function (item) {
                    item.classList.remove('active')
                })
                indicator.forEach(function (item) {
                    item.classList.remove('active')
                })

                item.classList.add('active')
                slides[item.dataset.index].classList.add('active')
            })
        })
    }
}

export function initSlider(element) {
    switchSlide(element)
}
